import { setRemoteDefinitions } from '@nx/angular/mf';
import { ExternalConfigService } from '@acadv/shell/config';

ExternalConfigService.loadAppConfig();

setRemoteDefinitions(ExternalConfigService.Config.remotes);

import('./bootstrap').catch((error) => {
  console.error('Failed to load the shell bootstrap module.', error);
});
